<template>
  <BatteryIcon
    v-if="battery == 'Full'"
    :blocks="3"
    color="#85e342"
    background="none"
  />
  <!-- 電波が良好で一定期間通信が行われていない場合 -->
  <BatteryIcon
    v-else-if="battery == 'Median' && heartBeatError == true && antenna == 4"
    :blocks="1"
    color="#e3a042"
    background="none"
  />
  <!-- 電波が悪くで一定期間通信が行われていない場合 -->
  <BatteryIcon
    v-else-if="battery == 'Median' && heartBeatError == true"
    :blocks="2"
    color="#e3a042"
    background="none"
  />
  <BatteryIcon
    v-else-if="battery == 'Median'"
    :blocks="2"
    color="#e3a042"
    background="none"
  />
  <BatteryIcon
    v-else-if="battery == 'Low'"
    :blocks="1"
    color="red"
    background="none"
  />
  <div class="battery-text">{{ battery }}</div>
</template>
<script>
import BatteryIcon from "@/components/devices/BatteryIcon";
export default {
  components: {
    BatteryIcon,
  },
  props: {
    battery: {
      type: String,
      require: true,
    },
    antenna: {
      type: String,
      require: true,
    },
    heartBeatError: {
      type: Boolean,
      require: true,
    },
  },
};
</script>
<style>
.battery-text {
  font-size: 10px;
}
</style>
